/** The Console's selected organization, remembered in this browser. */

const ORGANIZATION_STORAGE_KEY = "sylviq.console.organization";

export function savedOrganizationId(): string | null {
  try {
    return localStorage.getItem(ORGANIZATION_STORAGE_KEY);
  } catch {
    return null;
  }
}

export function saveOrganizationId(organizationId: string): void {
  try {
    localStorage.setItem(ORGANIZATION_STORAGE_KEY, organizationId);
  } catch {
    // A private-browsing session still has an active organization for this visit.
  }
}
